module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_ta1_b1_dark.78c0e9a4.svg";